export default __webpack_public_path__ + "static/media/sao-paulo.da42249f.png";